module.exports = __webpack_public_path__ + "static/media/arrow-from-bottom.e8d12ce8.svg";